export default "__VITE_ASSET__xpT_d5V9__"